import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { Brand } from './brand';

let initialized = false;
const initI18next = ({ brand }: { brand: Brand }) => {
    if (!initialized && brand) {
        initialized = true;
        i18n.use(Backend)
            .use(LanguageDetector)
            .use(initReactI18next)
            .init({
                ns: ['au', 'nz'],
                supportedLngs: ['en'],
                defaultNS: 'nz',
                fallbackLng: 'en',
                backend: {
                    loadPath: `${process.env.NEXT_PUBLIC_JUCY_DATA_API_BASE}/app/locales/css/${brand || 'jucy'}/{{ns}}/{{lng}}.json?_=${
                        process.env.NEXT_PUBLIC_APP_VERSION || Date.now()
                    }`,
                },
                interpolation: {
                    escapeValue: false,
                },
                react: {
                    bindI18n: 'languageChanged loaded',
                    nsMode: 'default',
                },
            });
    }
};

export default initI18next;
